import { Component, Input } from '@angular/core';
import { badgeConfig, colorType, sizeType, themeType } from '@core/types/types';
import { TranslateModule } from '@ngx-translate/core';
import { IconsComponent } from '../icons/icon.component';

@Component({
  imports: [TranslateModule, IconsComponent],
  standalone: true,
  selector: 'badge-component',
  templateUrl: './badge.component.html',
})
export class CustomBadgeComponent {
  @Input({ required: true }) config!: badgeConfig;

  protected iconSizes = {
    sm: '25',
    md: '30',
    lg: '40',
  };

    protected textSizes = {
    sm: '10',
    md: '13',
    lg: '16',
  };

  protected defaultConfig = {
    color: 'primary',
    theme: 'dark' as themeType,
    size: 'sm' as sizeType,
  };

  protected contraryThemes = {
    dark: 'light',
    light: 'dark',
  };


  ngOnInit() {
    if (!this.config.color) {
      this.config.color = this.defaultConfig.color as colorType;
    }

    if (!this.config.theme) {
      this.config.theme = this.defaultConfig.theme as themeType;
    }

    if (!this.config.size) {
      this.config.size = this.defaultConfig.size as sizeType;
    }
  }
}
